import React from 'react';
import Slider from '../../vendor/react-slick/slider';
import { H4 } from '@xo-union/tk-ui-typography';
import LazyloadImage from "../LazyloadImage";
import PrevArrow from '../CarouselArrows/prev-arrow';
import NextArrow from '../CarouselArrows/next-arrow';
import { isMobile } from "../../utilities/javascript/browser";
import styles from './styles.css';

export default class MoreInThisCollectionCarousel extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = props.isMobile;
    this.state = {
      isMobile: isMobile,
      arrows: !isMobile,
      slidesToShow: isMobile ? 2 : 5,
      cardStyle: isMobile ? { width: 154 } : { width: 260 },
    }
  }

  onWindowResize() {
    this.setState({
      isMobile: isMobile(),
      arrows: !isMobile(),
      slidesToShow: isMobile() ? 2 : 5,
      cardStyle: isMobile() ? { width: 154 } : { width: 260 },
    })
  }

  componentDidMount() {
    this.onWindowResize();
    if (window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  componentWillUnmount() {
    if (window && window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  handleSwipe = (direction) => {
    Fashion.Helpers.AnalyticsHelpers.bindMoreInThisCollectionCarouselImpression(direction);
  }

  render() {
    const { ProductCardsInfo } = this.props;
    const { arrows, slidesToShow, cardStyle, isMobile } = this.state;
    const a11yProps = { 'aria-hidden': true, 'tabindex': -1 };
    const settings = {
      accessibility: false,
      adaptiveHeight: true,
      arrows: arrows,
      className: 'slider variable-width',
      infinite: false,
      slidesToShow: slidesToShow,
      slidesToScroll: isMobile ? 1 : 5,
      swipeToSlide: true,
      speed: 300,
      variableWidth: isMobile,
      keepConsistentScroll: true,
      prevArrow: <PrevArrow a11yProps={a11yProps} iconCssName={styles['arrow-icon']}/>,
      nextArrow: <NextArrow a11yProps={a11yProps} iconCssName={styles['arrow-icon']}/>,
      onSwipe: this.handleSwipe,
    };

    let ProductCard = function (product, index) {
      return (
        <a id={`product-link-${product.id}`}
          class="collection-link"
          href={product.linking_slug}
          tabindex={-1}>
          <LazyloadImage
            containerClassName='more-in-this-collection-image-container'
            image={product.image}
            alt={product.alt}
            desktopWidth={236}
            mobileWidth={134}
            isLeadImage={false}
            img_ratio={product.img_ratio}
          />
        </a>
      )
    }

    return (
      <div class={styles['more-in-this-collection-container']} aria-hidden={true}  data-slide-to-show={slidesToShow}>
        <H4 as='h2' className={styles['section-title']}>More in this collection</H4>
        <Slider {...settings}>
          {
            ProductCardsInfo.map(function (product, index) {
              return <div style={cardStyle} className={styles['collection-card']}>
                {
                  ProductCard(product, index)
                }
              </div>
            })
          }
        </Slider>
      </div>
    )
  }
}
